import { render, staticRenderFns } from "./NsImage.vue?vue&type=template&id=0caec533&scoped=true&"
import script from "./NsImage.vue?vue&type=script&lang=js&"
export * from "./NsImage.vue?vue&type=script&lang=js&"
import style0 from "./NsImage.vue?vue&type=style&index=0&id=0caec533&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caec533",
  null
  
)

export default component.exports